var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFontistoArrowLeftL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fontisto:arrow-left-l"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.7299 5.99813L10.7618 18.9663L7.4298 15.6343L7.86105 24.2559L16.4827 24.6872L13.1507 21.3552L26.1189 8.38709L23.7299 5.99813Z",
    fill: "#4E0AA5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontistoArrowLeftL);
export default __webpack_public_path__ + "static/media/fontisto_arrow-left-l.8d957e173a9384759ae9c858ced4544e.svg";
export { ForwardRef as ReactComponent };